import { useEffect, useRef } from 'react'
import { useProfile } from '@ninetailed/experience.js-gatsby'
import { anchorLinkScroll } from '@toasttab/shared/src/utils/linkUtils'

const SCROLL_DELAY_MS = 200
const FALLBACK_TIMEOUT_MS = 2000

export function useNinetailedHashScroll(): void {
  const { status } = useProfile()

  const initialHashRef = useRef(
    typeof window !== 'undefined' ? window.location.hash : ''
  )
  const initialStatusRef = useRef<string | null>(null)
  const hasScrolledRef = useRef(false)

  if (initialStatusRef.current === null) {
    initialStatusRef.current = status
  }

  useEffect(() => {
    const hash = initialHashRef.current
    if (!hash) return
    if (initialStatusRef.current !== 'loading') return
    if (hasScrolledRef.current) return

    if (status === 'success' || status === 'error') {
      hasScrolledRef.current = true
      requestAnimationFrame(() => {
        setTimeout(() => anchorLinkScroll(hash), SCROLL_DELAY_MS)
      })
    }
  }, [status])

  useEffect(() => {
    const hash = initialHashRef.current
    if (!hash) return
    if (initialStatusRef.current !== 'loading') return

    const timer = window.setTimeout(() => {
      if (!hasScrolledRef.current) {
        hasScrolledRef.current = true
        anchorLinkScroll(hash)
      }
    }, FALLBACK_TIMEOUT_MS)

    return () => window.clearTimeout(timer)
  }, [])
}
